import {HttpModelConverter} from "../../../modules/core/converter/httpModel.converter";

export class PageHelper {

    public static convertRestPageToStorePage(restPage: any, converter?: HttpModelConverter<any>): any {
        const entities = restPage.content.map(value => converter ? converter.convert(value) : value);
        entities.page = {
            size: restPage.size,
            last: restPage.last,
            first: restPage.first,
            number: restPage.number,
            totalElements: restPage.totalElements,
            numberOfElements: restPage.numberOfElements,
            totalPages: restPage.totalPages
        };
        const restPageContent: [] = restPage.content;
        entities.currentPageItemIndexes$ =  restPageContent.map((value: any) => {
            // FIXME Not right!It should reuse EntityMetadataMap.selectId function. But I don't know how to do it.
            if (value?.summary?.id) {
                return value.summary.id;
            } else {
                return value.id;
            }
        })
        return entities;
    }
}
